import React from 'react';
import { useCommonContext, useOrderDetailsContext, } from '../../../hooks/useContexts';
import { ExportButton, PrintButton } from './index';
export var OrderDetailsPageHeader = function (_a) {
    var customerType = _a.customerType;
    var isDesktop = useCommonContext().isDesktop;
    var _b = useOrderDetailsContext(), orderDetailsData = _b.orderDetailsData, setAlertState = _b.setAlertState, setExportAlertState = _b.setExportAlertState;
    if (!isDesktop)
        return null;
    if (customerType === 'b2b' && orderDetailsData) {
        return (React.createElement("div", { className: "no-print sui-flex sui-justify-end sui-items-center sui-h-full" },
            React.createElement(ExportButton, { orderDetailsData: orderDetailsData, setAlertState: setExportAlertState }),
            React.createElement(PrintButton, { orderDetailsData: orderDetailsData, setAlertState: setAlertState })));
    }
    return null;
};
